import { Translation } from '../i18n-types';

const da: Translation = {};
export default da;
